import type { CoreConnectInvoicing } from '@flecto/types'

import { api } from '../../../services/api'

export async function getInvoicingProvider(): Promise<{
  user_integration: {
    invoice: CoreConnectInvoicing[]
  }
}> {
  const response = await api.get('/api/me/integrations/invoices')

  return response.data
}

